var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSortDescending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5L14.5605 15.4395L17.25 18.129V3H18.75V18.129L21.4395 15.4395L22.5 16.5L18 21L13.5 16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5H1.5V6H12V4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9H4.5V10.5H12V9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5H7.5V15H12V13.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortDescending);
export default __webpack_public_path__ + "static/media/ic-sort-descending.156303e2e521bb52748c95ab41901069.svg";
export { ForwardRef as ReactComponent };